<div class="wrapper client-style">
  <div class="working" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>
  <div class="success" *ngIf="!loading">
    <i class="fa fa-check-circle fa-4x" style="margin-bottom: 10px; color: green"></i>
    <span>¡Cita confirmada, te esperamos!</span>
  </div>
</div>
